import { h } from 'preact';
import { useCallback, useMemo, useRef } from 'preact/hooks';
import { embed } from '../../../../../configuration';
import { ENTER_BUTTTONS_LIST } from '../../../../../core/shortcut/types';
import { useNewStore, usePlayerContext, useStyles } from '../../../../common/hooks';
import { TEXT_LEVEL_2_FONT_SIZE } from '../../../../common/styles';
import { withBreakPoints } from '../../../hoc';
import {
  EMBED_POPUP_COPIED,
  EMBED_POPUP_TEXTAREA,
  EMBED_POPUP_TITLE,
  EMBED_POPUP_WRAPPER
} from './styles';

function EmbedScreen({
  copied,
  copyEmbedIframe
}) {
  const player = usePlayerContext();
  const wrapperRef = useRef(null);
  const setStyles = useStyles();
  const { embedError, message } = useNewStore('media', player);
  const { embedKey } = useNewStore('ui', player);

  const embedIframe = useMemo(() => (embedKey
    ? `<iframe width="560" height="315" src="${embed.iframe}${embedKey}" title="Lecteur vidéo embed France télévisions" frameborder="0" scrolling="no" allowfullscreen></iframe>`
    : ''), [embedKey]);

  const textToShow = useMemo(() => {
    if (embedError) {
      return message;
    }

    if (embedKey) {
      return embedIframe;
    }

    return 'Chargement...';
  }, [embedError, embedIframe, embedKey, message]);

  const copyEmbedLink = useCallback((e) => {
    e.stopPropagation();

    if (!embedKey) {
      e.preventDefault();
      return;
    }

    navigator.clipboard.writeText(textToShow);
    copyEmbedIframe();

    const modal = wrapperRef.current.parentElement;
    const closeEmbed = modal.querySelector('[name="btn-close-embed"]');
    closeEmbed?.focus();
  }, [copyEmbedIframe, embedKey, textToShow]);

  return (
    <div
      ref={wrapperRef}
      style={setStyles(EMBED_POPUP_WRAPPER)}
    >
      <div style={{ ...setStyles(EMBED_POPUP_TITLE) }}>Code à intégrer</div>
      <div
        className="ftv-magneto--btn ftv-magneto--focusable-item"
        style={{
          ...setStyles(TEXT_LEVEL_2_FONT_SIZE),
          ...EMBED_POPUP_TEXTAREA
        }}
        onClick={copyEmbedLink}
        tabIndex={0}
        onKeyDown={(e) => [13, 32 /* Space or Enter */, ...ENTER_BUTTTONS_LIST].includes(e.keyCode) && copyEmbedLink(e)}
        role="button"
      >
        <span tabIndex={-1} style={embedKey ? {} : { wordBreak: 'break-word' }}>{textToShow}</span>
      </div>
      <div style={setStyles(EMBED_POPUP_COPIED)}>
        <span hidden={!copied}>copié !</span>
      </div>
    </div>
  );
}

export default withBreakPoints(EmbedScreen);
